/* Halo — shared add-to-cart wiring for snippets/buy-bar.liquid.
   The 'sticky' bar holds the canonical [data-atc-add] button; every [data-gc-add]
   delegate .click()s it (or falls back to the product URL). Loaded once globally.
   Talks to window.HaloCart (assets/cart-drawer.js) and Shopify /cart/add.js. */
(function () {
  function setCount(n) {
    document.querySelectorAll('.halo-cart').forEach(function (cart) {
      var badge = cart.querySelector('.halo-cart__count');
      if (!badge) { badge = document.createElement('span'); badge.className = 'halo-cart__count'; cart.appendChild(badge); }
      badge.textContent = n; badge.style.display = n > 0 ? '' : 'none';
    });
  }

  function bindCanonical() {
    var atcBtn = document.querySelector('[data-atc-add]');
    if (!atcBtn || atcBtn.__bbBound || !window.fetch) return;
    atcBtn.__bbBound = true;
    var atcLabel = atcBtn.querySelector('[data-atc-label]');
    /* Captured ONCE, before any click can swap it to "Added" — otherwise a second
       click during the 2.4s confirm window latches the label permanently. */
    var def = atcLabel ? atcLabel.textContent : 'Add to cart';
    var resetTimer = null;
    atcBtn.addEventListener('click', function () {
      if (atcBtn.getAttribute('aria-disabled') === 'true' || atcBtn.classList.contains('is-loading')) return;
      var vid = atcBtn.getAttribute('data-vid');
      if (resetTimer) { clearTimeout(resetTimer); resetTimer = null; }
      atcBtn.classList.remove('is-error');
      atcBtn.classList.add('is-loading');
      if (window.HaloCart) {
        window.HaloCart.open();
        window.HaloCart.optimistic({
          title: atcBtn.getAttribute('data-title') || 'Halo',
          image: atcBtn.getAttribute('data-image') || '',
          url: atcBtn.getAttribute('data-url') || '#',
          priceCents: parseInt(atcBtn.getAttribute('data-price'), 10) || 0,
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
        });
      }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          atcBtn.classList.remove('is-loading'); atcBtn.classList.add('is-added');
          if (atcLabel) atcLabel.textContent = 'Added';
          setCount(cart.item_count);
          if (window.HaloCart) window.HaloCart.render(cart);
          resetTimer = setTimeout(function () { atcBtn.classList.remove('is-added'); if (atcLabel) atcLabel.textContent = def; }, 2400);
        })
        .catch(function () {
          /* Never leave the shopper believing an add succeeded — the drawer was
             opened optimistically, so say so on the button and resync it. */
          atcBtn.classList.remove('is-loading', 'is-added');
          atcBtn.classList.add('is-error');
          if (atcLabel) atcLabel.textContent = 'Couldn’t add — try again';
          if (window.HaloCart) window.HaloCart.refresh();
          resetTimer = setTimeout(function () { atcBtn.classList.remove('is-error'); if (atcLabel) atcLabel.textContent = def; }, 3200);
        });
    });
  }

  function bindDelegates() {
    document.querySelectorAll('[data-gc-add]').forEach(function (b) {
      if (b.__bbBound) return; b.__bbBound = true;
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-disabled') === 'true') return;
        var canon = document.querySelector('[data-atc-add]');
        if (canon) canon.click();
        else { var u = b.getAttribute('data-url'); if (u) window.location = u; }
      });
    });
  }

  function bind() { bindCanonical(); bindDelegates(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();
